"use client";

import React, { useState } from "react";
import InitialAvatar from "@/src/shared/components/atoms/InitialAvatar";

interface IHostAvatarProps {
  imageUrl?: string;
  firstName: string;
  lastName: string;
  size?: "sm" | "md" | "lg";
}

const HostAvatar: React.FC<IHostAvatarProps> = ({
  imageUrl,
  firstName,
  lastName,
  size = "md",
}) => {
  const [imageError, setImageError] = useState(false);

  const sizeClasses = {
    sm: "w-12 h-12",
    md: "w-16 h-16",
    lg: "w-20 h-20",
  };

  if (!imageUrl || imageError) {
    return (
      <InitialAvatar
        title={`${firstName} ${lastName}`}
        width={sizeClasses[size]}
        height={sizeClasses[size]}
        fontSize={
          size === "sm" ? "text-sm" : size === "md" ? "text-lg" : "text-xl"
        }
        className="ring-2 ring-white shadow-lg"
      />
    );
  }

  return (
    <div
      className={`${sizeClasses[size]} rounded-full overflow-hidden ring-2 ring-white shadow-lg`}
    >
      <img
        src={imageUrl}
        alt={`${firstName} ${lastName}`}
        className="w-full h-full object-cover"
        onError={() => setImageError(true)}
      />
    </div>
  );
};

export default HostAvatar;
